import styled from 'styled-components';

export const UnauthorizedLayout = styled.div`
  width: calc(100% - 290px);
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: auto;
`